import { render, staticRenderFns } from "./ProjectsProfitAndLossIncomeDataTableReadOnly.vue?vue&type=template&id=1632bebe"
import script from "./ProjectsProfitAndLossIncomeDataTableReadOnly.vue?vue&type=script&lang=js"
export * from "./ProjectsProfitAndLossIncomeDataTableReadOnly.vue?vue&type=script&lang=js"
import style0 from "./ProjectsProfitAndLossIncomeDataTableReadOnly.vue?vue&type=style&index=0&id=1632bebe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports